 //caseSuccess   //nomder
  const dataColumns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      render: (text, record, index) => index + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
    },
    {
      title: "เกรด",
      dataIndex: "GRDCOD",
      key: "GRDCOD",
    },
    {
      title: "สถานะสืบทรัพย์",
      dataIndex: "itemA",
      key: "itemA",
    },
    {
      title: "สถานะออกบอกเลิก",
      dataIndex: "itemB",
      key: "itemB",
    },
  ];
export default dataColumns;
